import { useCallback, useEffect, useState } from 'react';
import { useHttp } from '@hooks/use-http';

const useContainers = (country: string, station: string) => {
  const http = useHttp();
  const [data, setData] = useState<any>([]);

  const loadContainers = useCallback(async () => {
    try {
      const res: any = await http.induction.queryContainersRest(
        country,
        station,
        false,
      );
      setData(res?.data?.containersDynamic?.containers || []);
    } catch (e) {
      console.error('Error loading containers', e);
      setData([]);
    }
  }, [country, station, http]);

  const onAddToContainer = useCallback(
    async (
      orderId: string,
      containerId: string,
      source: string,
      routeId: string,
      routeStop: number,
      routePackage: number,
      idempotenceGroup: string,
      fixed: boolean,
    ) => {
      return await http.induction.addToContainerLastMile({
        station,
        country,
        orderId,
        containerId,
        source,
        routeId,
        routeStop,
        routePackage,
        idempotenceGroup,
        fixed,
      });
    },
    [station, country, http],
  );

  const onToggleContainer = useCallback(
    async (containerId: string, status: boolean) => {
      const response = await http.induction.toggleContainer(containerId, status);
      return response.status;
    },
    [http],
  );

  const onLmToMM = useCallback(
    async (containerId: string, destStation: string) => {
      await http.induction.lmToMMContainer(destStation, containerId);
    },
    [http],
  );

  useEffect(() => {
    loadContainers();
  }, [loadContainers]);

  return {
    onLmToMM,
    onAddToContainer,
    onToggleContainer,
    containers: data,
  };
};
export default useContainers;
